/* SoftySteps Size Finder — advisor only.
   It never touches the cart, the variant picker or the hidden id input, so it
   cannot conflict with Vitals. It prints a recommendation; the customer picks.
   The dialog uses showModal(), which puts it in the browser top layer — above
   every stacking context regardless of z-index. That is deliberate: the Sofy
   chat widget sits at z-index 2147483601 and would otherwise cover it. */
(function () {
  'use strict';

  /* +Comfort keeps the store's own US table; it tops out at EU 46, which is
     exactly +Comfort's largest size. */
  var US_COMFORT = [
    { us: [4, 5], eu: 36 }, { us: [6, 7], eu: 38 }, { us: [7.5, 8.5], eu: 40 },
    { us: [9, 10], eu: 42 }, { us: [10.5, 11], eu: 44 }, { us: [12, 13], eu: 46 }
  ];
  /* Ortho reaches EU 48, so its table extends past where the store's stops.
     Identical up to US 11; only the top is split (EU 47 ~ US 12.5, 48 ~ 13). */
  var US_ORTHO = [
    { us: [4, 5], eu: 36 }, { us: [6, 7], eu: 38 }, { us: [7.5, 8.5], eu: 40 },
    { us: [9, 10], eu: 42 }, { us: [10.5, 11], eu: 44 }, { us: [11.5, 12], eu: 46 },
    { us: [12.5, 12.5], eu: 47 }
  ];
  var US_MIN = 4, US_MAX = 13;

  function usToEu(table, n) {
    if (n < US_MIN || n > US_MAX) return null;
    var hit = table.filter(function (b) { return n >= b.us[0] && n <= b.us[1]; })[0];
    if (hit) return { eu: hit.eu, gap: false };
    var up = table.filter(function (b) { return b.us[0] > n; })[0];
    return up ? { eu: up.eu, gap: true } : null;
  }
  function seq(a, b) { var o = []; for (var v = a; v <= b + 1e-9; v++) o.push(Math.round(v * 10) / 10); return o; }
  function numberOptions(p, sys, half) {
    var r = sys === 'eu' ? (half ? p.euRange.half : p.euRange.whole)
                         : (half ? p.usRange.half : p.usRange.whole);
    return seq(r[0], r[1]).map(function (v) { return { label: String(v), val: v }; });
  }

  var COMFORT = {
    key: 'comfort', trim: false,
    bands: [{ band: 'EU 35-36', cm: 23.5 }, { band: 'EU 37-38', cm: 24.5 },
            { band: 'EU 39-40', cm: 25.5 }, { band: 'EU 41-42', cm: 26.5 },
            { band: 'EU 43-44', cm: 27.5 }, { band: 'EU 45-46', cm: 28.5 }],
    euMin: 35, euMax: 46,
    euRange: { whole: [33, 48], half: [33.5, 47.5] },
    usRange: { whole: [3, 15], half: [3.5, 14.5] },
    options: function (sys, half) { return numberOptions(this, sys, half); },
    resolve: function (sys, n) {
      var eu = n, gap = false, rounded = null;
      if (sys === 'us') {
        var c = usToEu(US_COMFORT, n);
        if (!c) return { out: n < US_MIN ? 'small' : 'large' };
        eu = c.eu; gap = c.gap;
      } else { eu = Math.ceil(n); if (eu !== n) rounded = eu; }
      if (eu < this.euMin) return { out: 'small' };
      if (eu > this.euMax) return { out: 'large' };
      return { i: Math.floor((eu - this.euMin) / 2), rounded: rounded, gap: gap, eu: eu };
    }
  };

  /* Ortho: a triple band's real size is its LARGEST number (42-44 is a 44).
     Exact fit when the customer's number equals that; otherwise the band
     needing the least trimming. The map is fixed, never computed. */
  var ORTHO = {
    key: 'ortho', trim: true,
    bands: [{ band: '38-40', cm: 26.0 }, { band: '39-41', cm: 27.5 },
            { band: '42-44', cm: 29.0 }, { band: '45-47', cm: 30.5 }],
    euMin: 38, euMax: 47,
    euRange: { whole: [36, 50], half: [36.5, 49.5] },
    usRange: { whole: [3, 15], half: [3.5, 14.5] },
    MAP: { 38: [0, 'cut'], 39: [0, 'cut'], 40: [0, 'match'], 41: [1, 'match'],
           42: [2, 'cut'], 43: [2, 'cut'], 44: [2, 'match'],
           45: [3, 'cut'], 46: [3, 'cut'], 47: [3, 'match'] },
    options: function (sys, half) { return numberOptions(this, sys, half); },
    resolve: function (sys, n) {
      var eu = n, gap = false, rounded = null;
      if (sys === 'us') {
        var c = usToEu(US_ORTHO, n);
        if (!c) return { out: n < US_MIN ? 'small' : 'large' };
        eu = c.eu; gap = c.gap;
      } else { eu = Math.ceil(n); if (eu !== n) rounded = eu; }
      if (eu < this.euMin) return { out: 'small' };
      if (eu > this.euMax) return { out: 'large' };
      var m = this.MAP[eu];
      return { i: m[0], fit: m[1], rounded: rounded, gap: gap, eu: eu };
    }
  };

  /* Kids: the US kids scale runs 9C..13.5C then rolls over to 1Y..3.5Y, so it
     is held as an ordered list and compared by POSITION, never by number —
     13C and 1Y are adjacent even though 13 > 1. */
  var KIDS_US = ['8C', '8.5C', '9C', '9.5C', '10C', '10.5C', '11C', '11.5C', '12C', '12.5C',
                 '13C', '13.5C', '1Y', '1.5Y', '2Y', '2.5Y', '3Y', '3.5Y', '4Y', '4.5Y'];
  var KIDS = {
    key: 'kids', trim: true,
    bands: [{ band: 'XS (3-5 years)', eu: [25, 27], us: [2, 5], cm: [15.0, 16.5] },
            { band: 'S (5-7 years)', eu: [28, 30], us: [6, 9], cm: [17.0, 18.5] },
            { band: 'M (7-10 years)', eu: [31, 33], us: [10, 13], cm: [19.0, 20.5] },
            { band: 'L (10-13 years)', eu: [34, 35], us: [14, 17], cm: [21.0, 22.5] }],
    euMin: 25, euMax: 35, usMin: 2, usMax: 17,
    euRange: { whole: [23, 37], half: [23.5, 36.5] },
    options: function (sys, half) {
      if (sys === 'eu') return numberOptions(this, 'eu', half);
      return KIDS_US.map(function (l, i) { return { label: l, val: i }; })
                    .filter(function (_, i) { return half ? i % 2 === 1 : i % 2 === 0; });
    },
    resolve: function (sys, v) {
      var i;
      if (sys === 'eu') {
        var eu = Math.ceil(v), rounded = (eu !== v ? eu : null);
        if (eu < this.euMin) return { out: 'small' };
        if (eu > this.euMax) return { out: 'large' };
        i = this.bands.map(function (b, k) { return eu >= b.eu[0] && eu <= b.eu[1] ? k : -1; })
                      .filter(function (k) { return k >= 0; })[0];
        return { i: i, fit: 'cut', rounded: rounded, eu: eu };
      }
      if (v < this.usMin) return { out: 'small' };
      if (v > this.usMax) return { out: 'large' };
      i = this.bands.map(function (b, k) { return v >= b.us[0] && v <= b.us[1] ? k : -1; })
                    .filter(function (k) { return k >= 0; })[0];
      return { i: i, fit: 'cut', eu: KIDS_US[v] };
    }
  };

  var PRODUCTS = {
    '4d-comfort-insole': COMFORT,
    'ortho-support-insole': ORTHO,
    'kids-support-insole': KIDS
  };

  Array.prototype.forEach.call(document.querySelectorAll('[data-size-finder]'), function (root) {
    var handle = root.getAttribute('data-product');
    var product = PRODUCTS[handle];
    if (!product) return;

    var L = (root.getAttribute('data-locale') || 'en').indexOf('ar') === 0 ? 'ar' : 'en';
    var T = JSON.parse(root.querySelector('[data-sf-i18n]').textContent);
    var lottieUrl = root.getAttribute('data-lottie');
    var tickUrl = root.getAttribute('data-tick');
    var clip = { ar: root.getAttribute('data-clip-ar'), en: root.getAttribute('data-clip-en') };
    var hasClip = product.key === 'ortho' && clip.ar && clip.en;

    /* Pair the trigger with the theme's Size Guide button on one line.
       They are separate product-details blocks, so the parent's layout is
       not ours to change — instead both move into a flex row we own.
       If the Size Guide block is absent or moved, nothing happens and the
       trigger simply renders where it already is. */
    (function pairWithSizeGuide() {
      /* previousElementSibling is the <style> this snippet emits, not the
         Size Guide block — search the shared parent instead. */
      var parent = root.parentNode;
      if (!parent) return;
      var guide = parent.querySelector(':scope > .product-popup');
      if (!guide) {
        var kids = parent.children, k;
        for (k = 0; k < kids.length; k++) {
          if (kids[k].className && kids[k].className.indexOf('product-popup') !== -1) { guide = kids[k]; break; }
        }
      }
      if (!guide || guide.parentNode.className.indexOf('sf-row') !== -1) return;
      var row = document.createElement('div');
      row.className = 'sf-row';
      guide.parentNode.insertBefore(row, guide);
      row.appendChild(guide);
      row.appendChild(root);
    })();

    var dlg = root.querySelector('.sf-dialog');
    var $ = function (s) { return root.querySelector(s); };
    var $$ = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };

    var st = { sys: null, half: null, num: null, res: null }, step = 0;
    var okAnim = null, lottieLoading = false;

    /* Lottie is fetched the first time the dialog opens, never on page load. */
    function script(src, next) {
      var el = document.createElement('script');
      el.src = src; el.onload = next; el.onerror = function () {};
      document.head.appendChild(el);
    }
    function loadLottie() {
      if (okAnim || lottieLoading || !lottieUrl || !tickUrl) return;
      lottieLoading = true;
      script(tickUrl, function () {
        script(lottieUrl, function () {
          try {
            okAnim = window.lottie.loadAnimation({
              container: $('.sf-lottie'), renderer: 'svg', loop: false, autoplay: false,
              animationData: window.SF_TICK
            });
            $('.sf-lottie').hidden = false; $('.sf-tick-fb').hidden = true;
            if (step === 3 && st.res && !st.res.out) okAnim.goToAndPlay(0, true);
          } catch (e) {}
        });
      });
    }

    function fmtCm(cm) {
      return Object.prototype.toString.call(cm) === '[object Array]'
        ? T.cmRange.replace('{a}', cm[0].toFixed(1)).replace('{b}', cm[1].toFixed(1))
        : T.cm.replace('{v}', cm);
    }
    function why(r) {
      var s = T.whyBase.replace('{sys}', st.sys === 'eu' ? T.euShort : T.usShort).replace('{n}', st.num);
      if (r.rounded) s += T.whyRound.replace('{r}', r.rounded);
      else if (r.gap) s += T.whyGap;
      return s + '.';
    }

    function grid() {
      var g = $('.sf-grid'); g.innerHTML = '';
      product.options(st.sys, st.half === 'half').forEach(function (o) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'sf-num'; b.textContent = o.label;
        if (product.resolve(st.sys, o.val).out) b.className += ' sf-num--off';
        b.addEventListener('click', function () {
          st.num = o.label; st.res = product.resolve(st.sys, o.val); go(3);
        });
        g.appendChild(b);
      });
    }

    function result() {
      var r = st.res, v = $('.sf-video');
      if (r.out) {
        $('.sf-ok').hidden = true; $('.sf-oor').hidden = false;
        if (v) v.pause();
        $('.sf-oor-title').textContent = r.out === 'small' ? T.oorSmall : T.oorLarge;
        $('.sf-oor-body').innerHTML = r.out === 'small' ? T.oorSmallBody : T.oorLargeBody;
        return;
      }
      $('.sf-oor').hidden = true; $('.sf-ok').hidden = false;
      var b = product.bands[r.i];
      $('.sf-band').textContent = b.band;
      $('.sf-band').classList.toggle('sf-band--long', product.key === 'kids');
      $('.sf-cm').textContent = fmtCm(b.cm);
      $('.sf-take').innerHTML = T.take.replace('{band}', '<strong>' + b.band + '</strong>');
      $('.sf-why').textContent = why(r);

      var fit = $('.sf-fit'), box = $('.sf-cutbox');
      if (product.key === 'comfort') {
        fit.hidden = true; box.hidden = true; $('.sf-notrim').hidden = false;
        if (v) v.pause();
      } else if (product.key === 'kids') {
        fit.hidden = true; $('.sf-notrim').hidden = true; box.hidden = false;
        $('.sf-cutnote').innerHTML = T.kidsTrim.replace('{band}', '<strong>' + b.band + '</strong>');
        if (v) { v.pause(); v.hidden = true; }
        $('.sf-vidcap').hidden = true;
      } else {
        $('.sf-notrim').hidden = true; fit.hidden = false;
        var match = r.fit === 'match';
        fit.textContent = match ? T.matchLine : T.cutLine;
        fit.classList.toggle('sf-fit--match', match);
        if (match) { box.hidden = true; if (v) v.pause(); }
        else {
          box.hidden = false;
          $('.sf-cutnote').innerHTML = T.cutNote
            .replace('{band}', '<strong>' + b.band + '</strong>')
            .replace('{size}', '<strong>' + r.eu + '</strong>');
          if (hasClip && v) {
            v.hidden = false; $('.sf-vidcap').hidden = false;
            var src = clip[L];
            if (v.getAttribute('src') !== src) { v.pause(); v.setAttribute('src', src); v.load(); }
          } else if (v) { v.hidden = true; $('.sf-vidcap').hidden = true; }
        }
      }
    }

    function go(n) {
      step = n;
      $$('.sf-step').forEach(function (s) { s.classList.toggle('is-on', +s.getAttribute('data-s') === n); });
      $$('.sf-bar').forEach(function (b, i) {
        b.classList.toggle('is-done', i < n);
        b.classList.toggle('is-now', i === n && n < 3);
      });
      $('.sf-back').hidden = n === 0;
      $('.sf-count').textContent = n < 3 ? T.step.replace('{a}', n + 1).replace('{b}', 3) : '';
      if (n === 2) grid();
      if (n !== 3) { var v = $('.sf-video'); if (v) v.pause(); }
      if (n === 3) { result(); if (okAnim && !st.res.out) okAnim.goToAndPlay(0, true); }
    }

    function open() {
      st = { sys: null, half: null, num: null, res: null };
      go(0);
      loadLottie();
      if (typeof dlg.showModal === 'function') dlg.showModal();
      else dlg.setAttribute('open', '');
    }
    function close() {
      var v = $('.sf-video'); if (v) v.pause();
      if (typeof dlg.close === 'function') dlg.close(); else dlg.removeAttribute('open');
    }

    $('.sf-open').addEventListener('click', open);
    $('.sf-x').addEventListener('click', close);
    $('.sf-done').addEventListener('click', close);
    $('.sf-back').addEventListener('click', function () { go(Math.max(0, step - 1)); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) close(); });
    dlg.addEventListener('close', function () { var v = $('.sf-video'); if (v) v.pause(); });

    $$('[data-sf-pick]').forEach(function (b) {
      b.addEventListener('click', function () {
        var val = b.getAttribute('data-sf-pick');
        if (step === 0) {
          st.sys = val;
          $('.sf-scale').textContent = val === 'eu' ? T.scaleEu : T.scaleUs;
          /* the half/whole examples must speak the chosen system — a US
             shopper was being shown EU numbers here */
          var eu = val === 'eu';
          var w = $('.sf-eg-whole'), hf = $('.sf-eg-half');
          if (w) w.textContent = eu ? T.egWholeEu : T.egWholeUs;
          if (hf) hf.textContent = eu ? T.egHalfEu : T.egHalfUs;
          go(1);
        }
        else { st.half = val; go(2); }
      });
    });
  });
})();
